<template>
  <div>
    <a-card
      :head-style="{ background: 'rgb(243, 243, 243)' }"
      :body-style="{ textAlign: 'center' }"
    >
      <template #title>
        <div class="header">
          <div class="left"><SearchOutlined />&nbsp;筛选查询</div>
          <div class="right">
            <button>查询结果</button>
          </div>
        </div>
      </template>
      <div class="card_body">
        <a-form layout="inline" class="form_style">
          <a-form-item label="供应商名称">
            <a-select class="wd" v-model:value="formState.supplyName">
              <a-select-option>全部</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="业务类型">
            <a-select class="wd" v-model:value="formState.businessType">
              <a-select-option
                v-for="(item, index) in businessTypeList"
                :key="index"
                :value="index"
              >
                {{ item }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="业务权限">
            <a-select class="wd" v-model:value="formState.businessPre">
              <a-select-option
                v-for="(item, index) in businessTypeList"
                :key="index"
                :value="index"
              >
                {{ item }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="配置类型">
            <a-select class="wd" v-model:value="formState.configType">
              <a-select-option
                v-for="(item, index) in businessTypeList"
                :key="index"
                :value="index"
              >
                {{ item }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <div style="margin-top: 10px"></div>
    <a-table
      :columns="columns"
      bordered
      :dataSource="dataSource"
      :pagination="false"
    >
      <template #title>
        <div class="header">
          <div class="left">
            <AlignLeftOutlined />
            数据列表
          </div>
          <div class="right">
            <router-link to="/shop/addConfig" replace>
              <a-button>添加</a-button>
            </router-link>
            <!-- <a-select class="wd1">
              <a-select-option></a-select-option>
            </a-select>
            <a-select class="wd1">
              <a-select-option></a-select-option>
            </a-select> -->
          </div>
        </div>
      </template>
      <template #isStart="{ text, record, index }">
        <a-switch
          checked-children="开"
          un-checked-children="关"
          v-model:value="record.state"
          @click="changeState(record)"
        ></a-switch>
      </template>
      <template #operation="{ text, record, index }">
        <a-popover>
          <template #content>
            <p>编辑</p>
            <p>删除</p>
          </template>
          <span>操作</span>
        </a-popover>
      </template>

      <template #footer>
        <div class="header">
          <div class="left"></div>
          <div class="right">
            <df-pagination :model="pageObj"></df-pagination>
          </div>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { SearchOutlined, AlignLeftOutlined } from "@ant-design/icons-vue";
import { ref, reactive, toRefs, toRef } from "vue";
import supply from "@/axios/supply";
export default {
  components: {
    SearchOutlined,
    AlignLeftOutlined,
  },
  setup() {
    let formState = reactive({
      businessType: "全部",
      businessPre: "全部",
      configType: "全部",
      supplyName: "全部",
    });
    const columns = [
      {
        title: "ID",
        dataIndex: "supplierId",
      },
      {
        title: "供应商名称",
        dataIndex: "supplierName",
      },
      {
        title: "OFFICE",
        dataIndex: "office",
      },
      {
        title: "配置类型",
        dataIndex: "businessType",
      },
      {
        title: "最后登录",
        dataIndex: "updateTime",
      },
      {
        title: "是否启用",
        dataIndex: "state",
        key: "state",
        slots: {
          customRender: "isStart",
        },
      },
      {
        title: "操作",
        dataIndex: "address",
        slots: {
          customRender: "operation",
        },
      },
    ];
    let dataSource = ref([]);
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });
    let submit = () => {
      supply.configList().then((res) => {
        dataSource.value = res;
      });
    };
    submit();
    const changeState = (row) => {
      let params = {
        lid: row.id,
        type: row.state == 1 ? 0 : 1,
      };
      supply.changeState(params).then(() => {
        notification.open({
          message: "修改成功",
          icon: <SmileOutlined style="color: #108ee9" />,
        });
      });
    };
    return {
      changeState,
      submit,
      businessTypeList: reactive(["全部", "国内", "国际"]),
      formState,
      pageObj,
      columns,
      dataSource,
    };
  },
};
</script>

<style lang='scss' scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.wd {
  width: 150px;
}
.wd1 {
  width: 80px;
  margin-left: 10px;
}
/deep/ .ant-card-head-title {
  padding: 10px 0;
}
/deep/ .ant-card-body {
  padding: 10px;
}
/deep/ .ant-card-bordered {
  box-shadow: none;
}
/deep/ .ant-pagination {
  margin: 0 !important;
}
/deep/ .ant-table-footer {
  padding: 10px 16px;
}
p {
  color: #1abc9c;
  cursor: pointer;
}
</style>